import { render, staticRenderFns } from "./OnlineChangeProcess.vue?vue&type=template&id=1686c220&scoped=true&"
import script from "./OnlineChangeProcess.vue?vue&type=script&lang=js&"
export * from "./OnlineChangeProcess.vue?vue&type=script&lang=js&"
import style0 from "./OnlineChangeProcess.vue?vue&type=style&index=0&id=1686c220&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1686c220",
  null
  
)

export default component.exports